import $ from 'jquery';
import 'bootstrap/js/dist/tab';
import TereaStructure from './components/terea-structure';
import RevealWhenVisible from '../../components/reveal-when-visible';
import TereaVariantsSlider from './components/terea-variants-slider';
$(() => {
    TereaStructure.init();
    TereaVariantsSlider.init();
    RevealWhenVisible.init();
});
